import { useEffect, useState } from 'react'
import { FileText, Receipt, RotateCcw, Trophy, RefreshCw } from 'lucide-react'
import RefundManagementTab from './RefundManagementTab'
import RechargeRankingTab from './RechargeRankingTab'
import InvoiceApplicationsTab from './InvoiceApplicationsTab'
import PartialRefundDetailsTab from './PartialRefundDetailsTab'
import AutopayManagementTab from './AutopayManagementTab'

const SUB_TABS = [
  { id: 'refunds', label: '已支付订单', icon: RotateCcw },
  { id: 'autopay-management', label: '自动续费管理', icon: RefreshCw },
  { id: 'recharge-ranking', label: '充值排行', icon: Trophy },
  { id: 'invoice-applications', label: '发票申请管理', icon: FileText },
  { id: 'partial-refund-details', label: '退款明细', icon: Receipt }
]

export default function OrderManagementTab({ initialSubTab }) {
  const [activeSubTab, setActiveSubTab] = useState('refunds')

  useEffect(() => {
    if (SUB_TABS.some((tab) => tab.id === initialSubTab)) {
      setActiveSubTab(initialSubTab)
    }
  }, [initialSubTab])

  const renderContent = () => {
    switch (activeSubTab) {
      case 'recharge-ranking':
        return <RechargeRankingTab />
      case 'invoice-applications':
        return <InvoiceApplicationsTab />
      case 'partial-refund-details':
        return <PartialRefundDetailsTab />
      case 'autopay-management':
        return <AutopayManagementTab />
      case 'refunds':
      default:
        return <RefundManagementTab />
    }
  }

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-4">
        <div className="flex flex-wrap gap-3">
          {SUB_TABS.map((tab) => {
            const Icon = tab.icon
            const isActive = activeSubTab === tab.id

            return (
              <button
                key={tab.id}
                onClick={() => setActiveSubTab(tab.id)}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 border border-blue-200 dark:border-blue-800'
                    : 'bg-gray-50 dark:bg-gray-900/50 text-gray-600 dark:text-gray-400 border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700'
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            )
          })}
        </div>
      </div>

      {renderContent()}
    </div>
  )
}
